<template>
  <div>
    <ministry-breadcrumbs
      :mainTitle="$route.meta.title"
      :breadcrumbs="$route.meta.breadCrumb"
    />
    <b-card>
        <b-row class="justify-content-between align-items-center">
          <b-col class="d-flex align-items-center">
            <h3> المستخدمين </h3>
          </b-col>
          <!-- <b-col md="3">
            <search-input
              placeholder="البحث بحسب الإسم"
              v-model="searchKey.full_name"
            />
          </b-col>
          <b-col md="3">
            <form-select
            placeholder="البحث بحسب المحافظة"
              :getOptionLabel="(x) => x.name_ar"
              :reduce="(x) => x.id"
              id="resGov"
              ep="v2/guest/selects/governorates"
              ref="resGov"
              v-model="searchKey.governorate_id"
            />
          </b-col>-->
          <b-col md="3"> 
            <form-select
            placeholder="عرض المستخدمين بصفة"
            id="social-role"
            :options="options"
            rules="required"
            v-model="searchKey.slug"
            :getOptionLabel="(x) => x.text"
            :reduce="(x) => x.value"
          />
          </b-col>
        </b-row>
        <hr />
        <alert
          massage="يجب تحديد الصفة التي سيتم عرض المستخدمين وفقاُ لها "
          class="w-100 mx-1"
          v-if="Object.keys(searchKey).length === 0 || (Object.keys(searchKey).length === 1 && searchKey.slug== null )"
        ></alert>
      <data-table v-else ref=usersAvailability :fields="fields" ep="v2/ministry/get-users-by-manager">
        <template #cell(actions)="row">
            <div class="d-flex align-items-center justify-content-end">
              <b-button @click="onClickedChangeStatus(row.item)" :variant="row.item.is_online ? 'outline-success' : 'outline-danger'">
                {{ row.item.is_online ? 'متوفر' : 'غير متوفر' }}
              </b-button>
            </div>
        </template>
      </data-table>
      <!-- <b-modal
        footer-class="removed"
        centered
        title="الدخول بصفة"
        v-model="modal"
        ref="modal"
        hide-close-button
        backdrop="static"
      >
      <template #modal-header="{ close }">
     
        <h5>الدخول بصفة</h5>
      </template>
      
      <validation-observer ref="typeOfRole">
        <b-form class="auth-login-form mt-2" @submit.prevent="fetchUser">
          <form-select
            label="صفة المشارك (ضمن الكيان المجتمعي)"
            id="social-role"
            :options="options"
            rules="required"
            v-model="form.slug"
            :getOptionLabel="(x) => x.text"
            :reduce="(x) => x.value"
          />
          <b-button
              :disabled="loading"
              class="mt-2"
              variant="primary"
              type="submit"
              block
            >
              <b-spinner class="align-middle mx-1" v-if="loading" small />
              تأكيد
            </b-button>
        </b-form>
      </validation-observer>
      </b-modal> -->
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BFormCheckbox,
  BDropdown,
  BDropdownItem,
  BTab,
  BTabs,
  BBadge ,
  VBTooltip ,
  BCol ,
  BRow ,
  BSkeleton ,
  BTable , 
  BModal ,
  BForm ,
  BSpinner
} from "bootstrap-vue";
import DataTable from "@/components/data-table/index.vue";
import { mapActions, mapGetters } from "vuex";
import saveBtn from "@/components/loader-btn";
import FormModal from "@/components/FormModal.vue";
import MinistryBreadcrumbs from "@/modules/ministry/components/MinistryBreadcrumbs.vue";
import RoleModal from "@/modules/ministry/components/RoleModal.vue";
import SearchInput from "@/components/SearchInput.vue";
import FormSelect from "@/components/form-select";
import debounce from "lodash.debounce";
import { ValidationObserver } from "vee-validate";
import AuthHelpers from "@/utils/auth-helpers";
import Alert from "@/components/Alert.vue";

export default {
  components: {
    BCard,
    BButton,
    DataTable,
    BFormCheckbox,
    saveBtn,
    BDropdown,
    BDropdownItem,
    FormModal,
    MinistryBreadcrumbs,
    BTab,
    BTabs,
    RoleModal , 
    BBadge ,
    BCol ,
    BRow ,
    BSkeleton ,
    BTable ,
    SearchInput ,
    FormSelect ,
    BModal ,
    ValidationObserver,
    BForm ,
    BSpinner ,
    Alert
  },
  data: () => {
    return {
      loading : false ,
      activeTableIndex: 0,
      RoleModal : false ,
      isFeatureEnabled: false,
      editModal : false ,
      ministry_user_id :null,
      editForm : {},
      searchKey:{},
      listOptions:[],
      form : {},
      modal : true ,
      id:null ,
      models: [
        {
          title: "أدوار الوزارة",
          slug: "MIN",
        },
        {
          title: "أدوار المنظمة",
          slug: "NGO",
        },
      ],

      activeSlug: "MIN",

      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "full_name",
          label: "الاسم الكامل",
        },
        {
          key: "governorate.name",
          label: "المحافظة",
        },
        { key: "actions", label: " " },
      ],
      updateModel: false,
      show: false,
      create: false,
      update: true,
      delete_s: true,
      roleFormSchema: {
        name: {
          component: "FormInput",
          key: "name",
          attrs: {
            label: "اسم الدور",
            rules: "required",
          },
        },
        name_rols: {
          component: "FormSelect",
          key: "role_ids",
          attrs: {
            id: "role_ids",
            ep: "v2/selects/roles",
            reduce: (x) => x.id,
            getOptionLabel: (x) => x.name,
            label: "الصلاحيات",
            rules: "required",
            multiple: true,
          },
        },
      },
    };
  },
  methods: {
    ...mapActions("Ministry/Settings/UsersAvailability", ["updateUserVvailability"]),

    onDelete(item) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الدور", {
          title: "تأكيد حذف الدور",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteRole({ id: item.ministry_user_id, slug: this.activeSlug }).then(() => {
              this.$refs.estatesTable.refreshTable();
            });
        });
    },
    onClickedChangeStatus(item){
      console.log("item" , item)
      let message = item.is_online ? 'هل أنت متأكد من إنك تريد جعل المستخدم غير متوفر ؟' : 'هل أنت متأكد من إنك تريد جعل المستخدم متوفر ؟'
      this.$bvModal
        .msgBoxConfirm(message, {
          title: "تأكيد تغيير حالة المستخدم",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.updateUserVvailability({ id: item.id , is_online : item.is_online }).then(() => {
              this.$refs.usersAvailability.refreshTable();
              // this.id = null
            });
        });
    },
    onDeleteTransictionRole(item) {
      this.$bvModal
        .msgBoxConfirm("هل أنت متأكد من حذف الدور", {
          title: "تأكيد حذف الدور",
          size: "sm",
          okVariant: "danger",
          okTitle: "تأكيد",
          cancelTitle: "إلغاء",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value)
            this.deleteTransictionRole({ id: item.id}).then(() => {
              this.$refs.transactionRolesTable.refreshTable();
              this.id = null
            });
        });
    },
    onUpdateClicked(form) {
      var toUpdate = {
        name: form.name,
      };
      this.$refs.estateModalUser.init(toUpdate);
      this.updateModel = true;
    },
    toggleFeature() {
      this.isFeatureEnabled = !this.isFeatureEnabled;
    },
    onAddClicked() {
      this.$refs.estateModalUser.init({});
      this.updateModel = true;
    },
    onModalConfirmed() {},
    onClickAddTransactionRoles(){
      this.RoleModal = true
    },
    onClickEditTransactionRoles(item){

      console.log(item)
      this.ministry_user_id = this.id
      this.editForm.idEdit = item.id
      this.editForm.data =[{}]
      this.editForm.data[0].transaction_role_id = item.transactionRole.id
      this.editForm.data[0].transaction_type_id = item.transactionType.id
      if(item.governorate){

        this.editForm.data[0].governorate_id = item.transactionRole.id
      }
      this.$refs.editActivityModal.init(this.editForm);
      this.editModal = true

    },
    onAddTransactionRoles(form){
      const keys = Object.keys(form.data);
      var req = new FormData();
      req.append(`ministry_user_id`, form.ministry_user_id);
      form.data.forEach((obj, index) => {
        for (var key in obj) {
          req.append(`data[${index}][${key}]`, obj[key]);
        }
      });
      this.createTransictionRole({ data:req }).then(() => {
        this.$refs.transactionRolesTable.refreshTable();
        this.RoleModal = false
      });
    },
    onEditTransactionRoles(form){
      console.log('form' , form)
      const keys = Object.keys(form.data);
      var req = new FormData();
      form.data.forEach((obj, index) => {
        for (var key in obj) {
          if(`${key}` !== 'idEdit'){
            req.append(`${key}`, obj[key]);
          }
          
        }
      });
      req.append(`ministry_user_id`, form.ministry_user_id);
      this.updateTransictionRole({ data:req , id:form.idEdit }).then(() => {
        this.$refs.transactionRolesTable.refreshTable();
        this.editModal = false
        this.id = null
      });
    },
    async fetchUser() {
      await this.$refs.typeOfRole.validate().then(async (success) => {
        if (success) {
          this.$refs.usersAvailability.setQueryParams(this.form);
          this.$refs.usersAvailability.refreshTable();
          this.modal = false
        }
      });
    },
    

  },
  
  watch:{
    async id(val) {
      if(val){
        await this.getTransictionRole({ id: this.id})
      }
        
    },
    searchKey: {
      deep: true,
      handler: debounce(function (value) {
        this.$refs.usersAvailability.setQueryParams(this.searchKey);
        this.$refs.usersAvailability.refreshTable();
      }, 300),
    },
   },
  directives: {
    "b-tooltip": VBTooltip,
  },
  computed: {
    ...mapGetters("Ministry/Settings/Roles", [
      "parmassins",
      "loadingParmassins",
      "working" , 
      "loadingTransictionRole" , 
      "transictionRole" ,
      
    ]),
    options() {
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "employee") ){
        // let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "employee");
        // this.listOptions.push({ text: "موظف", value: result.slug  })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "head_of_regulation_and_governance"))
      {
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "head_of_regulation_and_governance");
        this.listOptions.push({ text: "رئيس دائرة", value: result.slug  })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "central_employee")){
        // let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "central_employee");
        // this.listOptions.push({ text: 'موظف مركزي', value: result.slug })
      }
      if (AuthHelpers.getTransactionRoles().some(item => item.slug === "director_of_social_affairs_and_labor")){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "director_of_social_affairs_and_labor");
        this.listOptions.push({ text: "مدير الشؤون الاجتماعية والعمل", value: result.slug })
      }
      if(AuthHelpers.getTransactionRoles().some(item => item.slug === "director_of_ngos")){
        let result = AuthHelpers.getTransactionRoles().find(obj => obj["slug"] === "director_of_ngos");
        this.listOptions.push({ text: 'مدير المنظمات غير الحكومية', value: result.slug })
      }
      return this.listOptions  ;
    },
  },
};
</script>
